import {all} from 'redux-saga/effects';
import authSagas from './features/auth/sagas';
import {commonSagas} from './common/actions';
import categorySagas from './features/category/sagas';
import productSagas from './features/product/sagas';
import tagSagas from './features/tag/sagas';
import articleSagas from './features/article/sagas';
import bannerSagas from './features/banner/sagas';
import contactMessageSagas from './features/contact-message/sagas';
import customerSagas from './features/customer/sagas';
import userSagas from './features/user/sagas';
import systemConfigSagas from './features/system-config/sagas';
import dashboardSagas from './features/dashboard/sagas';

function* AppSagas() {
    yield all([
        commonSagas(),
        authSagas(),
        categorySagas(),
        productSagas(),
        tagSagas(),
        articleSagas(),
        bannerSagas(),
        contactMessageSagas(),
        customerSagas(),
        userSagas(),
        systemConfigSagas(),
        dashboardSagas(),
    ]);
}

export default AppSagas;
